import React , {useState}from 'react'

import { ApiCallPost, ApiCallPostMultipart } from '../ApiCall/ApiCall';


import { useNavigate , useLocation } from "react-router-dom";


import axios from 'axios';

import GetUrl from '../ApiCall/GetUrl';


export default function CfdiLoader() {

    const [file, setFile] = useState(null);


    const navigate = useNavigate();


    async function handleUpload(e )
    {
        e.preventDefault() ;

        var formData = new FormData()
        if (file) {
          

          console.log( "Antes que nada " + file.name ) ;

          formData.append(
            "file",
            file
        );

          console.log( "FormData = " , formData )
        }
        else{
            console.log( "No hay archivo")
            return ;
        }
        

        axios.post( GetUrl() + `cfdi`,  formData  )
        .then((response) => {
            console.log( "regresando de cfdi")
            console.log( response.data )

          

            // Ejmplo de forma de pasar parametros
            navigate( "/configdetail", { state :{ id : response.data.idCaso[0]} } )

            return ;
      
        })
        .catch((err) =>{
            console.log( err ) ;
        })


        // try {
        //     const response = await axios.post(`your_api_endpoint`, formData, { headers: { "Content-Type": "multipart/form-data" } })
        //     console.log(response);
      
        //   } catch (error ) {
        //     console.error(error);
        //   }
    
    }

    function handleFileChange( e )
    {

        console.log( "fileName keys = " ,  e.target.files[0].name )

        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    }

  return (
    <div>

    <form id='form'>

    <div className="input-group">
        <input id="file" type="file" onChange={handleFileChange} />
    </div>

    {file && (
        <section>
          File details:
          <ul>
            <li>Name: {file.name}</li>
            <li>Type: {file.type}</li>
            <li>Size: {file.size} bytes</li>
            
          </ul>
        </section>
      )}

      {file && (
        <button 
          onClick={handleUpload}
          className="submit"
        >Upload a file</button>
      )}

      </form>
    </div>
    
  )
}


///////// 9 + 5 + 6 = 20 + 5 + 6 